import {Injectable} from '@angular/core';
import {ChangelogService} from 'app/changelog/changelog.service';
import {Administration} from 'app/documents/administrations';
import {PadType} from 'app/element-ref.service';
import {DocumentFragment} from 'app/fragment/types';
import {DocumentService} from 'app/services/document.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ConditionASTNode} from '../types/condition-ast-node';
import {EqualityRelation, PermissionInput} from '../types/permissions';
import {FalseOnPadTypes} from './false-on-pad-types';
import {PermissionsHandler} from './permissions-handler';

@Injectable()
export class AdministrationPermissionsHandler implements PermissionsHandler {
  constructor(private _documentService: DocumentService, private _changelogService: ChangelogService) {}

  public getInputType(): PermissionInput {
    return PermissionInput.ADMINISTRATION;
  }

  @FalseOnPadTypes(PadType.NO_PAD)
  public handle(condition: ConditionASTNode, padType: PadType): Observable<boolean> {
    const administration: Administration = this._getAdministration(condition);
    const documentStream: Observable<DocumentFragment> = this._getDocumentStream(padType);
    switch (condition.relation) {
      case EqualityRelation.EQUALS:
        return documentStream.pipe(
          map((document: DocumentFragment) => document.documentData.administration === administration)
        );
      case EqualityRelation.NOT_EQUALS:
        return documentStream.pipe(
          map((document: DocumentFragment) => document.documentData.administration !== administration)
        );
      default:
        throw new Error(`Unsupported equality relation ${condition.relation}`);
    }
  }

  /**
   * Returning main document if one exists, if not returning published document.
   */
  private _getDocumentStream(padType: PadType): Observable<DocumentFragment> {
    return padType === PadType.MAIN_EDITABLE
      ? this._documentService.getDocumentStream()
      : this._changelogService.getPublishedDocumentStream();
  }

  private _getAdministration(condition: ConditionASTNode): Administration {
    if (condition.value === null) {
      return null;
    }

    const administration: Administration = Administration[condition.value as string];

    if (administration !== undefined) {
      return administration;
    } else {
      throw new Error(`Unknown Administration: ${condition.value}`);
    }
  }
}
